import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import React from "react";
import { BarChartType } from "../../../types/charts";
import { BarChartWrapper } from "./ChartComponents";

const BarChart = ({
  data,
  customOptions,
}: {
  data: BarChartType;
  customOptions?: Highcharts.Options;
}) => {
  if (!data || data.length === 0 || typeof window === undefined) {
    return null;
  }
  var colors = Highcharts.getOptions().colors;

  let colorArr = [];
  let checkColorArr = [];
  let colorIndex = 0;

  data.sort((a, b) => a.parent_index - b.parent_index);

  window.Highcharts = Highcharts;

  const chartConfig: Highcharts.Options = {
    chart: {
      type: "bar",
      animation: false,
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: data.map((d) => d.name),
      title: {
        text: null,
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Items (count)",
        align: "low",
      },
      labels: {
        overflow: "allow",
      },
    },
    tooltip: {
      valueSuffix: " items",
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: false,
        },
      },
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "Count",
        type: "bar",
        colorByPoint: true,
        data: data.map((d) => {
          if (!colorArr.includes(d.parent_index)) {
            colorArr.push(d.parent_index);
            colorIndex++;
          }
          const categoryColor = colors[colorIndex - 1];
          const customColor = "#abd3e1";

          if (categoryColor != undefined) {
            return { name: d.name, y: d.data, color: colors[colorIndex - 1] };
          }
          return { name: d.name, y: d.data, color: customColor };
        }),
        animation: false,
      },
    ],
  };

  return (
    <BarChartWrapper>
      <HighchartsReact
        highcharts={Highcharts}
        options={customOptions ? customOptions : chartConfig}
      />
    </BarChartWrapper>
  );
};

export default BarChart;
